import React from 'react';


export default function OutlinePanel({ fixed, className }) {
  return (
    <div id="outlinePanel" className={`${fixed ? 'fixed' : 'overlay'} ${className || ''}`}>
      <div id="outlineHeader">
        <h3>Outline</h3>
      </div>
      <div id="outlineContent">
        <p>Document headings will appear here.</p>
      </div>
    </div>
  );
}
